<script>
    import VTextField from 'vuetify/es5/components/VTextField/VTextField';
    import validations from "./validations";

    export default VTextField.extend({
        name: 'vat-field',
        extends: VTextField,
        props: {
            outline: { type: Boolean, default: true},
            rules: {
                default: function () {
                    return validations.checkVAT;
                }
            },
            type: {
                default: 'number'
            },
            "validate-on-blur":{
                default: true
            },
            "prepend-inner-icon": {
                default: 'fa-id-card'
            }
        }
    })

</script>

<style scoped>

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }

</style>
